import { VideoOverlayPayload } from '@/scripts/store/modules/video/mutations/manageVideoPlayerOverlays/createOverlayHelper';
import { FilmQuotaManifest } from './manifest';

export class FilmQuotaManifestProvider {
  private _manifest: FilmQuotaManifest;

  constructor(manifest: FilmQuotaManifest) {
    this._manifest = manifest;
  }

  get manifest(): FilmQuotaManifest {
    // Always return a deep copy of the manifest. Prevent manifest from being modified when passed by reference.
    return JSON.parse(JSON.stringify(this._manifest));
  }

  isExceeded(count: number): boolean {
    return count >= this.manifest.quota;
  }

  getPresentation(count: number): VideoOverlayPayload | null {
    const matchingPresentation = this.manifest.presentations[count];

    if (matchingPresentation != null) {
      return matchingPresentation;
    }

    if (this.isExceeded(count)) {
      return this.manifest.presentations.exceeded || null;
    }

    return null;
  }
}
